interface EchangeDonneesConfigurationFields {
    id?: string;
    domain: string;
    login: string;
    password: string;
    sortant: boolean;
}

export class EchangeDonneesConfiguration implements EchangeDonneesConfigurationFields {

    id?: string;
    domain: string;
    login: string;
    password: string;
    sortant: boolean;

    constructor(configuration?: EchangeDonneesConfigurationFields) {
        if (configuration == null) {
            this.initWithDefaultValues();
            return;
        }

        this.id = configuration.id;
        this.domain = configuration.domain;
        this.login = configuration.login;
        this.password = configuration.password;
        this.sortant = configuration.sortant;
    }

    static fromJson(data: any): EchangeDonneesConfiguration {
        return new EchangeDonneesConfiguration({
            id: data.edc_id,
            domain: data.edc_domain,
            login: data.edc_login,
            password: data.edc_password,
            sortant: data.edc_sortant === '1'
        });
    }

    initWithDefaultValues() {
        this.id = null;
        this.domain = '';
        this.login = '';
        this.password = '';
        this.sortant = false;
    }

    isEmpty() {
        return this.id == null
            && this.domain === ''
            && this.login === ''
            && this.password === ''
            && this.sortant === false;
    }

    toJson() {
        return {
            edc_id: this.id,
            edc_domain: this.domain,
            edc_login: this.login,
            edc_password: this.password,
            edc_sortant: this.sortant === true ? '1' : '0'
        };
    }

}
